import _classCallCheck from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Split } from '../split';
export var ProjectionComponent = /*#__PURE__*/function (_Split) {
  _inherits(ProjectionComponent, _Split);

  var _super = _createSuper(ProjectionComponent);

  function ProjectionComponent(name, specifiedProjection, size, data) {
    var _this;

    _classCallCheck(this, ProjectionComponent);

    _this = _super.call(this, Object.assign({}, specifiedProjection), // all explicit properties of projection
    {
      name: name
    } // name as initial implicit property
    );
    _this.specifiedProjection = specifiedProjection;
    _this.size = size;
    _this.data = data;
    _this.merged = false;
    return _this;
  }
  /**
   * Whether the projection parameters should fit provided data.
   */


  _createClass(ProjectionComponent, [{
    key: "isFit",
    get: function get() {
      return !!this.data;
    }
  }]);

  return ProjectionComponent;
}(Split);